import React, { useEffect, useState } from 'react';
import '../../css/methods/Description.css';

import Image from 'react-image-webp';

import image1 from '../../images/study-method/description1.jpeg';
import imageWebp1 from '../../images/study-method/description1.webp';

import image2 from '../../images/study-method/description2.jpeg';
import imageWebp2 from '../../images/study-method/description2.webp';

import { IoBulbOutline, IoPaperPlaneOutline, IoCogOutline, IoSchoolOutline } from 'react-icons/io5';

const Description = () => {
	const [active, setActive] = useState(false);

	const handleLink = (e) => {
		e.preventDefault();
		const target = e.target.getAttribute('href');
		const location = document.querySelector(target).offsetTop;
		window.scrollTo({
			left: 0,
			top: location - 80,
		});
	};

	useEffect(() => {
		setTimeout(() => {
			setActive(true);
		}, 100);
	}, [active]);

	return (
		<div className='Description' style={active ? { opacity: 1 } : { opacity: 0 }}>
			<div className='description-content'>
				<div className='description-content-header'>
					<h2 className='description-content-title'>Máster en Escultura para Impresión 3D</h2>
					<div className='description-content-separator'></div>
				</div>
				<p>
					Aprenderás ZBrush desde cero con contenido de iniciación que te permita adaptarte al
					Software y empezar a crear esculturas listas para imprimir en 3D.
				</p>
				<ul>
					<li>
						<IoBulbOutline className='description-icon' />
						Incluye cursos ZBrush de diferentes niveles.
					</li>
					<li>
						<IoPaperPlaneOutline className='description-icon' />
						Se lleva una curva de aprendizaje guiada.
					</li>
					<li>
						<IoCogOutline className='description-icon' />
						Enseñanza del proceso de impresión 3D.
					</li>
					<li>
						<IoSchoolOutline className='description-icon' />
						Se obtiene un nivel intermedio en escultura ZBrush para impresión 3D.
					</li>
				</ul>
				<a href='#contenido' onClick={handleLink} className='button'>
					Ver Cursos del Máster
				</a>
			</div>
			<div className='description-images-container'>
				<div className='description-image image-description-up'>
					<Image src={image1} webp={imageWebp1} />
				</div>
				<div className='description-image image-description-down'>
					<Image src={image2} webp={imageWebp2} />
				</div>
			</div>
		</div>
	);
};

export default Description;
